import { firstSourceInstanceApi } from '~sharedApi/main/config/readyInstance/firstSourceInstanceApi'
import { secondSourceInstanceApi } from '~sharedApi/main/config/readyInstance/secondSourceInstanceApi'
import { ApiSourceType } from '~sharedLib'

export const getInstance = (sourceType: ApiSourceType) => {
	switch (sourceType) {
		case ApiSourceType.First: {
			return firstSourceInstanceApi
		}
		case ApiSourceType.Second: {
			return secondSourceInstanceApi
		}
	}
}
